var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 14.5V13.1667C14.6668 11.9241 13.817 10.88 12.6668 10.584M10.3335 2.69384C11.3108 3.08943 12.0002 4.04754 12.0002 5.16667C12.0002 6.28579 11.3108 7.2439 10.3335 7.63949M11.3335 14.5C11.3335 13.2575 11.3335 12.6362 11.1305 12.1462C10.8599 11.4928 10.3407 10.9736 9.68732 10.703C9.19726 10.5 8.57601 10.5 7.3335 10.5H5.3335C4.09099 10.5 3.46973 10.5 2.97967 10.703C2.32627 10.9736 1.80713 11.4928 1.53648 12.1462C1.3335 12.6362 1.3335 13.2575 1.3335 14.5M9.00016 5.16667C9.00016 6.63943 7.80626 7.83333 6.3335 7.83333C4.86074 7.83333 3.66683 6.63943 3.66683 5.16667C3.66683 3.69391 4.86074 2.5 6.3335 2.5C7.80626 2.5 9.00016 3.69391 9.00016 5.16667Z",
    stroke: "#101828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f458ea04cedec2a8b39a623f561a09f9.svg";
export { ForwardRef as ReactComponent };